import { AiBridge } from '@/types/aiBridge'
import { PaginatedResponse, WithListParams } from '@/types/pagination'
import { vpApi } from './vpApi'

// The viewset declares no filter backends, so only the pagination params are honoured.
export type AiBridgeListParams = WithListParams

const getAiBridgeList = async (params: AiBridgeListParams) => {
  const res = await vpApi.get<PaginatedResponse<AiBridge[]>>(
    `/v1/devices/ai-bridges/`,
    {
      params
    }
  )

  return res.data
}

const getAiBridgeDetails = async (bridgeId: string) => {
  const res = await vpApi.get<AiBridge>(`/v1/devices/ai-bridges/${bridgeId}/`)
  return res.data
}

export type CreateAiBridgeParams = {
  name: string
  device_uuid: string
  path: string
}

const createAiBridge = async (data: CreateAiBridgeParams) => {
  const res = await vpApi.post<AiBridge>(`/v1/devices/ai-bridges/`, data)
  return res.data
}

const deleteAiBridge = (bridgeId: string) => {
  return vpApi.delete(`/v1/devices/ai-bridges/${bridgeId}/`)
}

type TaskResponse = {
  task_id: string
}

export type TestAiBridgePathParams = {
  deviceUuid: string
  path: string
}

// Checks a path that has no bridge record yet, so it is keyed by device rather than
// by bridge. Returns a Celery task id to poll for the device's answer.
const testAiBridgePath = async ({
  deviceUuid,
  path
}: TestAiBridgePathParams) => {
  const res = await vpApi.post<TaskResponse>(
    `/v1/devices/ai-bridges/${deviceUuid}/test/`,
    { path }
  )
  return res.data
}

// Re-checks a stored bridge; the backend reuses the path already on the record.
const testAiBridge = async (bridgeId: string) => {
  const res = await vpApi.post<TaskResponse>(
    `/v1/devices/ai-bridges/${bridgeId}/test/`
  )
  return res.data
}

const restartAiBridge = (bridgeId: string) => {
  return vpApi.post(`/v1/devices/ai-bridges/${bridgeId}/restart/`)
}

export const aiBridgeApi = {
  getAiBridgeList,
  getAiBridgeDetails,
  createAiBridge,
  deleteAiBridge,
  testAiBridgePath,
  testAiBridge,
  restartAiBridge
}
